import Tween from "tween.ts"
import Animation from "../../../../src/animation/Animation";
import { Coord } from "../../../../src/types/Interface";
import AngleBg from "../entities/AngleBg";


export default class DrawAngleBgAnim extends Animation {
  AngleBg: AngleBg;
  cCoord: Coord;
  constructor(AngleBg: AngleBg, radian: number, cCoord: Coord, onComp: () => void) {
    super();
    this.AngleBg = AngleBg;
    this.cCoord = cCoord;
    new Tween.Tween({...AngleBg})
      .to({ startRadian: radian }, 2000)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((ABg: AngleBg) => {
        this.AngleBg.draw(ABg.startRadian, ABg.endRadian)
      })
      .onComplete(() => onComp())
      .start()
  }
}